import { TextField } from "@mui/material";
import React from "react";

import { server } from "../../../common";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useSelectAccess } from "../../../store/stateFunctions";

const initialValues = {
  title: "",
  date: "",
  description: "",
  location: "",
};

const IndustryAdvertise = ({ role }) => {
  const user = useSelectAccess("Industry User");

  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      title: Yup.string().min(2, "Enter a Advertisement Title"), // Should be min(1) or min(2) or any other number
      description: Yup.string()
        .min(2, "Enter Advertisement Description")
        .required("Please Enter Your Advertisement Description"),
      date: Yup.string().min(2, "Select Date").required("Please Select date"),
      location: Yup.string()
        .min(2, "Enter Location")
        .required("Please Enter Location"),
    }),

    onSubmit: (values, action) => {
      console.log(values);
      server
        .post("/advertisment/addadvertisment", values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("Advertisement Sent successfully");
              resetForm();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  return (
    <>
      {console.log(values.errors)}
      {console.log(values)}

      <section className="">
        <div className="container py-5 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-8">
              <div className="card" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className=" ">
                    <div className="card-body p-4 text-black">
                      <form onSubmit={handleSubmit}>
                        {/* <div className="d-flex align-items-center mb-3 pb-1">
                        <i
                          className="fas fa-cubes fa-2x me-3"
                          style={{ color: "#ff6219" }}
                        />
                        <span className="h1 fw-bold mb-0">Logo</span>
                      </div> */}
                        <h5
                          className="fw-normal mb-3 pb-3"
                          style={{ letterSpacing: 1 }}
                        >
                          Add Advertisement
                        </h5>
                        <div className="form-outline mb-2">
                          <TextField
                            name="title"
                            margin="dense"
                            type="text"
                            placeholder="Title"
                            variant="outlined"
                            label=" Title"
                            value={values.title}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.title ? (
                            <p className="text-danger">{errors.title}</p>
                          ) : null}
                        </div>
                        <div className="form-group mb-2">
                          <TextField
                            name="date"
                            margin="dense"
                            type="date"
                            variant="outlined"
                            label="Date"
                            value={values.date}
                            onChange={handleChange}
                            InputProps={{
                              inputProps: {
                                min: new Date().toISOString().substring(0, 10),
                              },
                            }}
                            fullWidth
                            required
                            style={{ margin: "8px 0" }}
                            InputLabelProps={{ shrink: true }}
                          />
                          {errors.date ? (
                            <p className="text-danger mb-0">{errors.date}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="description"
                            margin="dense"
                            type="text"
                            placeholder="Description"
                            variant="outlined"
                            label="Description"
                            value={values.description}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.description ? (
                            <p className="text-danger">{errors.description}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="location"
                            margin="dense"
                            type="text"
                            placeholder="location"
                            variant="outlined"
                            label="Location"
                            value={values.location}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.location ? (
                            <p className="text-danger">{errors.location}</p>
                          ) : null}
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            className="banner text-white rounded-5 p-2 border-0 w-50"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IndustryAdvertise;
